// export const baseUrl = "https://localhost:44362/api";
// export const url = "https://test-api.riskmentor.com/api"
const url = process.env.REACT_APP_URL || "https://localhost:44322/api"
// console.log(url);
export const baseUrl = url
export const getUrl = (suffix: string, contextId?: number) =>
  contextId ? `${baseUrl}/context/${contextId}${suffix}` : `${baseUrl}${suffix}`

export const getHeaders = (token: string) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`
})

export const getUrlForNonContext = (suffix: string) => `${baseUrl}${suffix}`
